

<template>
    <div>
		<a-modal
		:width='"50rem"'
		id='main-handhomes'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:dialog-style="{ top: '6vh'}"
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div style="position: relative;top: .44rem;">{{fundFlag == 1?'債券添加':'債券審核'}}</div>
			</div>
            <div style="display: flex;">
				<!-- :"gland"'-->
				<div class="wland" >債券信息</div>
			</div>
			<div id='tubody-mainsk1'>
                <div id='handitemedit1'>
                    <div class="tabelMoreFzView main-mybody">
                        <div class="tabelMoreFzViewIn">
                            <!-- 1 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">帳戶號碼：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled="true" v-model="form.account"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">客戶名稱：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled="true" v-model="form.customer_name"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 2 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">電郵地址：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled="true" v-model="form.email"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right" >電話號碼：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled="true" v-model="form.phone_number"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 3-1 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">產品編號：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled="true" v-model="form.bond_code"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">產品名稱：</div>
                                    <div style="width: 100%;">
                                        <a-input :disabled="true" v-model="form.bond_name"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 4-1 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">風險評級：</div>
                                    <a-input :disabled="true" v-model="form.risk_type"></a-input>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">投資取向評級：</div>
                                    <a-input :disabled="true" v-model="form.score"></a-input>
                                </div>
                            </div>
                            <!-- 5 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_right">參考買入金額：</div>
                                    <div style="width: 100%;display: flex;align-items: center;">
                                        <a-select :class="{'border_red': obj.falg1}" @change="obj.falg1=false" v-model="form.latest_price_currency" style="width: 35%;flex-shrink: 0;margin-right: 10px;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <a-input v-model="form.latest_price" @blur="blurClick(1)" @focus="focusClick(1)" @change="moneyClick(1)" :class="{'border_red': obj.falg2}" @input="obj.falg2=false"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">成交價格：</div>
                                    <div style="width: 100%;display: flex;align-items: center;">
                                        <a-select :class="{'border_red': obj.falg3}" @change="obj.falg3=false" v-model="form.transaction_price_currency" style="width: 35%;flex-shrink: 0;margin-right: 10px;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <a-input v-model="form.transaction_price" @blur="blurClick(2)" @focus="focusClick(2)" @change="moneyClick(2)" :class="{'border_red': obj.falg4}" @input="obj.falg4=false"></a-input>
                                    </div>
                                </div>
                            </div>

                            <!-- 7 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">入場費：</div>
                                    <div style="width: 100%;display: flex;align-items: center;">
                                        <a-select :class="{'border_red': obj.falg5}" @change="obj.falg5=false" v-model="form.initial_amount_currency" style="width: 35%;flex-shrink: 0;margin-right: 10px;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <a-input v-model="form.initial_amount" @blur="blurClick(3)" @focus="focusClick(3)" @change="moneyClick(3)" :class="{'border_red': obj.falg6}" @input="obj.falg6=false"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_right">認購金額：</div>
                                    <div style="width: 100%;display: flex;align-items: center;">
                                        <a-select :class="{'border_red': obj.falg7}" @change="obj.falg7=false" v-model="form.subscription_amount_currency" style="width: 35%;flex-shrink: 0;margin-right: 10px;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <a-input v-model="form.subscription_amount" @blur="blurClick(4)" @focus="focusClick(4)" @change="moneyClick(4)" :class="{'border_red': obj.falg8}" @input="obj.falg8=false"></a-input>
                                    </div>
                                </div>
                            </div>

                            <!-- 9 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">票面值：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.nominal_value" @blur="blurClick(5)" @focus="focusClick(5)" @change="moneyClick(5)" :class="{'border_red': obj.falg9}" @input="obj.falg9=false" ></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_left">年度票息：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.annual_coupon" @blur="blurClick(6)"  type="number" :class="{'border_red': obj.falg10}" @input="obj.falg10=false" suffix="%"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 9_1 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">派息頻率：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.coupon_frequency" :class="{'border_red': obj.falg18}" @change="obj.falg18=false" style="width: 100%;">
                                            <a-select-option v-for="(item,index) in factionalList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_left">股息貨幣：</div>
                                    <div style="width: 100%;">
                                        <a-select v-model="form.currency" :class="{'border_red': obj.falg19}" @change="obj.falg19=false" style="width: 100%;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                    </div>
                                </div>
                            </div>
                            <!-- 10 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">首次包管費：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.first_warranty_fee" @blur="blurClick(7)"  type="number" :class="{'border_red': obj.falg11}" @input="obj.falg11=false" suffix="%"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_left">年度包管費：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.annual_warranty_fee" @blur="blurClick(8)" @focus="focusClick(8)" @change="moneyClick(8)" type="number" :class="{'border_red': obj.falg12}" @input="obj.falg12=false" suffix="%"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 11 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">佣金：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.commission" @blur="blurClick(9)" @focus="focusClick(9)" @change="moneyClick(9)" type="number" :class="{'border_red': obj.falg13}" @input="obj.falg13=false" suffix="%"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_left">最低佣金：</div>
                                    <div style="width: 100%;display: flex;align-items: center;">
                                        <a-select :class="{'border_red': obj.falg14}" @change="obj.falg14=false" v-model="form.lowest_commission_currency" style="width: 35%;flex-shrink: 0;margin-right: 10px;">
                                            <a-select-option v-for="(item,index) in currencyList" :key="index" :value="parseInt(item.value)">{{item.text_cn}}</a-select-option>
                                        </a-select>
                                        <a-input v-model="form.lowest_commission" @blur="blurClick(10)" @focus="focusClick(10)" @change="moneyClick(10)" :class="{'border_red': obj.falg15}" @input="obj.falg15=false"></a-input>
                                    </div>
                                </div>
                            </div>
                            <!-- 12 -->
                            <div class="table_flex table_bottom">
                                <div class="table_flex table_flex_left">
                                    <div class="table_div_left">平台費：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.platform_fee" @blur="blurClick(11)" @focus="focusClick(11)" @change="moneyClick(11)" type="number" :class="{'border_red': obj.falg16}" @input="obj.falg16=false" suffix="%"></a-input>
                                    </div>
                                </div>
                                <div style="width: 5%;flex-shrink: 0;"></div>
                                <div class="table_flex">
                                    <div class="table_div_left">剩餘年期：</div>
                                    <div style="width: 100%;">
                                        <a-input v-model="form.remaining_years" :class="{'border_red': obj.falg17}" @input="obj.falg17=false" ></a-input>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class='warp_daochu' v-if="bondBuyAudit && form.handle != 2 && form.review_nodes != 2">
                        <div style="padding-left: .5rem;width:31.5rem">
                            <a-textarea v-model='remark' placeholder=" " allow-clear style='width: 100%;' />
                        </div>
                        <div style="padding: .35rem 0;" >
                            <button class='btn1' @click='shTgEvent(2)' style="background-color: #ed4849;">審核拒絕</button>
                            <button class='btn1 btnx' @click='shTgEvent(1)'>審核通過</button>
                        </div>
                    </div>
                </div>
			</div>
		</a-modal>
	</div>

</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import App from '@/assets/app.js';

	export default {
		props: ['fundFlag','param'],
		data() {
			return {
                obj:{
                    falg1:false,
                    falg2:false,
                    falg3:false,
                    falg4:false,
                    falg5:false,
                    falg6:false,
                    falg7:false,
                    falg8:false,
                    falg9:false,
                    falg10:false,
                    falg11:false,
                    falg12:false,
                    falg13:false,
                    falg14:false,
                    falg15:false,
                    falg16:false,
                    falg17:false,
                    falg18:false,
                    falg19:false,
                },
                form:{
                    account:'',
                    customer_name:'',
                    email:'',
                    phone_number:'',
                    bond_code:'',
                    bond_name:'',
                    nominal_value:'',
                    remaining_years:'',
                    risk_type:'',
                    score:'',

                    latest_price:'',
                    latest_price_currency:'',
                    subscription_amount:'',
                    subscription_amount_currency:'',
                    transaction_price:'',
                    transaction_price_currency:'',
                    initial_amount:'',
                    initial_amount_currency:'',
                    transaction_time:'',
                    nominal_value:'',
                    annual_coupon:'',
                    first_warranty_fee:'',
                    annual_warranty_fee:'',
                    lowest_commission:'',
                    lowest_commission_currency:'',
                    commission:'',
                    platform_fee:'',
                    remaining_years:'',
                    coupon_frequency:'',
                    currency:'',

                    // latest_price                                参考价格
                    // latest_price_currency                       参考价格货币种类
                    // subscription_amount                         认购金额
                    // subscription_amount_currency                认购金额货币种类
                    // transaction_price                           成交价格
                    // transaction_price_currency                  成交价格货币种类
                    // initial_amount                              入场费
                    // initial_amount_currency                     入场费货币种类
                    // transaction_time                            成交时间
                    // nominal_value                               票面值
                    // annual_coupon                               年度息票
                    // first_warranty_fee                          首次包管费
                    // annual_warranty_fee                         年度包管费
                    // lowest_commission                           最低佣金
                    // lowest_commission_currency                  最低佣金货币种类
                    // commission                                  佣金
                    // platform_fee                                平台费
                  
                },
                factionalList:[
                    {
                        text_cn:'每月',
                        text_en:'Monthly',
                        value:'1'
                    },
                    {
                        text_cn:'每季',
                        text_en:'Quarterly',
                        value:'2'
                    },
                    {
                        text_cn:'半年度',
                        text_en:'Semi-Annually',
                        value:'3'
                    },
                    {
                        text_cn:'年度',
                        text_en:'Annually',
                        value:'4'
                    },
                    {
                        text_cn:'非固定',
                        text_en:'Incidental',
                        value:'5'
                    },
                ],
                dividendList:[
                    {
                        text_cn:'股息再投資',
                        text_en:'Reinvest',
                        value:'1',
                        disabled:false,
                    },
                    {
                        text_cn:'現金',
                        text_en:'Cash',
                        value:'2',
                        disabled:false,
                    },
                    {
                        text_cn:'視乎帳戶股息選擇',
                        text_en:'Depends on default option',
                        value:'3',
                        disabled:true,
                    },
                ],
                currencyList:[
                    {
                        text_cn:'港幣',
                        text_en:'HKD',
                        value:'1'
                    },
                    {
                        text_cn:'美元',
                        text_en:'USD',
                        value:'2'
                    },
                    {
                        text_cn:'人民幣',
                        text_en:'CNY',
                        value:'3'
                    },
                    {
                        text_cn:'日元',
                        text_en:'JPY',
                        value:'4'
                    },
                    {
                        text_cn:'澳元',
                        text_en:'AUD',
                        value:'5'
                    },
                    {
                        text_cn:'新加坡元',
                        text_en:'SGD',
                        value:'6'
                    },
                    {
                        text_cn:'台幣',
                        text_en:'TWD',
                        value:'7'
                    },
                    {
                        text_cn:'馬幣',
                        text_en:'MYR',
                        value:'8'
                    },
                ],
                riskList:[
                    {
                        text_cn:'最低風險',
                        text_en:'Very Low',
                        value:'1'
                    },
                    {
                        text_cn:'較低風險',
                        text_en:'Comparatively Low',
                        value:'2'
                    },
                    {
                        text_cn:'中等風險',
                        text_en:'Medium',
                        value:'3'
                    },
                    {
                        text_cn:'較高風險',
                        text_en:'Comparatively High',
                        value:'4'
                    },
                    {
                        text_cn:'最高風險',
                        text_en:'Very High',
                        value:'5'
                    },
                ],
                jjlxList:[
                    {
                        text_cn:'混合資產基金',
                        text_en:'Mutual Fund',
                        value:'1'
                    },
                    {
                        text_cn:'基金中的基金',
                        text_en:'Fund of Funds',
                        value:'2'
                    },
                    {
                        text_cn:'貨幣市場基金',
                        text_en:'Money Market Funds',
                        value:'3'
                    },
                    {
                        text_cn:'均衡基金',
                        text_en:'Balanced Fund',
                        value:'4'
                    },
                    {
                        text_cn:'定息基金',
                        text_en:'Fixed Income Fund',
                        value:'5'
                    },
                    {
                        text_cn:'股票基金',
                        text_en:'Equity Fund',
                        value:'6'
                    },
                    {
                        text_cn:'指數基金',
                        text_en:'Index Fund',
                        value:'7'
                    },
                    {
                        text_cn:'另類基金',
                        text_en:'Alternative Investment Fund',
                        value:'8'
                    }
                ],
                remark:'',
                visible:true,
                bjFlag : false,
                bondBuyAudit: this.$store.state.rolesdata.indexOf('bondBuyAudit') >= 0,
				editFund: this.$store.state.rolesdata.indexOf('editFund') >= 0,
			}
		},
		mounted() {
            this.getdata()
		},
		methods: {
            focusClick(val){
                if (val == 1) {
                    if (this.form.latest_price) {
                        this.form.latest_price = this.form.latest_price.replace(/,/g, '');
                    }
                }
                if (val == 2) {
                    if (this.form.transaction_price) {
                        this.form.transaction_price = this.form.transaction_price.replace(/,/g, '');
                    }
                }
                if (val == 3) {
                    if (this.form.initial_amount) {
                        this.form.initial_amount = this.form.initial_amount.replace(/,/g, '');
                    }
                }
                if (val == 4) {
                    if (this.form.subscription_amount) {
                        this.form.subscription_amount = this.form.subscription_amount.replace(/,/g, '');
                    }
                }
                if (val == 5) {
                    if (this.form.nominal_value) {
                        this.form.nominal_value = this.form.nominal_value.replace(/,/g, '');
                    }
                }
                if (val == 10) {
                    if (this.form.lowest_commission) {
                        this.form.lowest_commission = this.form.lowest_commission.replace(/,/g, '');
                    }
                }
              
            },
            moneyClick(val){
                if (val == 1) {
                    if (this.form.latest_price) {
                        this.form.latest_price = this.form.latest_price.match(/\d+\.?\d{0,3}/,'')
                    }
                }
                if (val == 2) {
                    if (this.form.transaction_price) {
                        this.form.transaction_price = this.form.transaction_price.match(/\d+\.?\d{0,3}/,'')
                    }
                }
                if (val == 3) {
                    if (this.form.initial_amount) {
                        this.form.initial_amount = this.form.initial_amount.match(/\d+\.?\d{0,3}/,'')
                    }
                }
                if (val == 4) {
                    if (this.form.subscription_amount) {
                        this.form.subscription_amount = this.form.subscription_amount.match(/\d+\.?\d{0,2}/,'')
                    }
                }
                if (val == 5) {
                    if (this.form.nominal_value) {
                        this.form.nominal_value = this.form.nominal_value.match(/\d+\.?\d{0,2}/,'')
                    }
                }
                if (val == 10) {
                    if (this.form.lowest_commission) {
                        this.form.lowest_commission = this.form.lowest_commission.match(/\d+\.?\d{0,2}/,'')
                    }
                }
              
            },
            blurClick(val){
                if (val == 1) {
                    this.form.latest_price =  this.getArea(Number(this.form.latest_price).toFixed(3))
                }
                if (val == 2) {
                    this.form.transaction_price =  this.getArea(Number(this.form.transaction_price).toFixed(3))
                }
                if (val == 3) {
                    this.form.initial_amount =  this.getArea(Number(this.form.initial_amount).toFixed(3))
                }
                if (val == 4) {
                    this.form.subscription_amount =  this.getArea(Number(this.form.subscription_amount).toFixed(2))
                }
                if (val == 5) {
                    this.form.nominal_value =  this.getArea(Number(this.form.nominal_value).toFixed(2))
                }
                if (val == 6) {
                    this.form.annual_coupon =  Number(this.form.annual_coupon).toFixed(3)
                }
                if (val == 7) {
                    this.form.first_warranty_fee =  Number(this.form.first_warranty_fee).toFixed(2)
                }
                if (val == 8) {
                    this.form.annual_warranty_fee =  Number(this.form.annual_warranty_fee).toFixed(2)
                }
                if (val == 9) {
                    this.form.commission =  Number(this.form.commission).toFixed(2)
                }
                if (val == 10) {
                    this.form.lowest_commission =  this.getArea(Number(this.form.lowest_commission).toFixed(2))
                }
                if (val == 11) {
                    this.form.platform_fee =  Number(this.form.platform_fee).toFixed(2)
                }

             
            },
            getArea(area) {
                return String(area).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            handleInput(val){
              
                if(val == 2 ){
                    this.form.fund_name_en = this.form.fund_name_en.replace(/[\u4e00-\u9fa5]/g, '');
                }
            },
            formatDate(valTime,ind) {
                // const date = new Date(valTime);
                // const formattedDate = date.toISOString().split('T')[0];
                // console.log(this.form.issue_date );
                const date = new Date(valTime);
                let year = date.getFullYear();
                let month = date.getMonth() + 1; // 月份是从 0 开始的，所以需要加1
                let day = date.getDate();
                let formattedDate = year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;
                if (ind == 1) {
                    this.form.issue_date = formattedDate;
                }
                // if (ind == 2) {
                //     this.form.subscription_frequency = formattedDate;
                // }
                if (ind == 3) {
                    this.form.valuation_date = formattedDate;
                }
            },
            // formattedDate() {
            //     const parts = this.originalDate.split("/");
            //     const newDate = parts[2] + "-" + parts[1] + "-" + parts[0];
            //     return newDate;
            // },
            getdata(){
             
                this.$ajax({
                    method: 'post',
                    url: this.$api.getBondOrderDetailById,
                    data: {
                        type:this.param.type,
                        id:this.param.id,
                }
                }).then(res => {
                    if (res.data.qmiscode === 1000) {
                        this.form = res.data;
                        console.log(this.form);
                        if (res.data.remaining_years) {
                            this.form.remaining_years = this.form.remaining_years + '個月'
                        }

                    } else {
                        this.$message.warning(res.data.qmismsg)
                    }
                })
            },
            shTgEvent(val){
                if (val == 1) {
                    if (!this.form.latest_price_currency) {
                        this.obj.falg1 = true
                        return
                    }
                    if (!this.form.latest_price) {
                        this.obj.falg2 = true
                        return
                    }
                    if (!this.form.transaction_price_currency) {
                        this.obj.falg3 = true
                        return
                    }
                    if (!this.form.transaction_price) {
                        this.obj.falg4 = true
                        return
                    }
                    if (!this.form.initial_amount_currency) {
                        this.obj.falg5 = true
                        return
                    }
                    if (!this.form.initial_amount) {
                        this.obj.falg6 = true
                        return
                    }
                    if (!this.form.subscription_amount_currency) {
                        this.obj.falg7 = true
                        return
                    }
                    if (!this.form.subscription_amount) {
                        this.obj.falg8 = true
                        return
                    }
                    if (!this.form.nominal_value) {
                        this.obj.falg9 = true
                        return
                    }
                    if (!this.form.annual_coupon) {
                        this.obj.falg10 = true
                        return
                    }
                    if (!this.form.coupon_frequency) {
                        this.obj.falg18 = true
                        return
                    }
                    if (!this.form.currency) {
                        this.obj.falg19 = true
                        return
                    }
                    if (!this.form.first_warranty_fee) {
                        this.obj.falg11 = true
                        return
                    }
                    if (!this.form.annual_warranty_fee) {
                        this.obj.falg12 = true
                        return
                    }
                    if (!this.form.commission) {
                        this.obj.falg13 = true
                        return
                    }
                    if (!this.form.lowest_commission_currency) {
                        this.obj.falg14 = true
                        return
                    }
                    if (!this.form.lowest_commission) {
                        this.obj.falg15 = true
                        return
                    }
                    if (!this.form.platform_fee) {
                        this.obj.falg16 = true
                        return
                    }
                    if (!this.form.remaining_years) {
                        this.obj.falg17 = true
                        return
                    }
                }
               
                // return
                if (val == 2 && !this.remark) {
                    this.$message.warning('請填寫備註信息')
                    return
                }else{
                    if (!this.remark) {
                        this.remark = '資料齊全'
                    }
                }
                this.form.remark = this.remark
                this.form.is_pass = val
                this.form.id = this.param.id
                
                this.$ajax({
                    method: 'post',
                    url: this.$api.auditBondSubscriptionOrder,
                    data:this.form
                }).then(res => {
                    if (res.data.qmiscode === 1000) {
                        this.$emit('child')
                    } else {
                        this.$message.warning(res.data.qmismsg)
                    }
                })
            },
            resetting(){
                this.form={
                    account:'',
                    customer_name:'',
                    email:'',
                    phone_number:'',
                    bond_code:'',
                    bond_name:'',
                    nominal_value:'',
                    remaining_years:'',
                    risk_type:'',
                    score:'',
                   
                    latest_price:'',
                    latest_price_currency:'',
                    subscription_amount:'',
                    subscription_amount_currency:'',
                    transaction_price:'',
                    transaction_price_currency:'',
                    initial_amount:'',
                    initial_amount_currency:'',
                    transaction_time:'',
                    nominal_value:'',
                    annual_coupon:'',
                    first_warranty_fee:'',
                    annual_warranty_fee:'',
                    lowest_commission:'',
                    lowest_commission_currency:'',
                    commission:'',
                    platform_fee:'',
                    remaining_years:'',
                    coupon_frequency:'',
                    currency:'',

                }
            },
			savefn() {
                this.$emit('child', 0)
                this.resetting()
			},
            handleOk(){
			},
            handleCancel(){
				this.$emit('child', 0)
                this.resetting()
			},

		}
	}
</script>
<style>
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
        -webkit-appearance: none; 
        margin: 0; 
    }
    .border_red{
        border-color: red !important;
    }
    .border_red .ant-input{
        border-color: red !important;
    }
    .border_red .ant-select-selection{
        border-color: red !important;
    }
    .border_red .ant-calendar-picker-input{
        border-color: red !important;
    }
</style>
<style scoped>
    .table_flex{
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 0.8rem;
    }
    .table_bottom{
        margin-bottom: 0.7rem;
    }
    .table_div_left{
        flex-shrink: 0;
        width: 6rem;
    }
    .table_div_right{
        flex-shrink: 0;
        width: 6rem;
    }
	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn {
		background-color: #fff;
		padding: 0.7rem 0;
		border-radius: 4px;
		overflow: hidden;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList {
		padding: 0.5rem 0;
		border-bottom: 1px #f3f3f3 solid;
		display: flex;
		align-items: flex-start;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList:last-child {
		border: none;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .left {
		width: 24%;
		color: #000;
		font-size: 0.8rem;
	}

	#handitemedit1 .center {
		/* height: 1.7rem;
		    line-height: 1.7rem; */
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList .center {
		font-size: 0.8rem;
		width: calc(70% - 2rem);
		color: #000;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	#handitemedit1 .tabelMoreFzView .tabelMoreFzViewIn .tabelMoreFzViewInList img {
		width: 1.2rem;
		height: 1.2rem;
		margin: auto 0;
		margin-left: auto;
	}
</style>
<style lang="scss">
#main-handhomes{
		.ant-select-selection{
			color: #000;
			background-color: #fff;
		}
		 .ant-input-disabled {
		    color: #000;
		    background-color: #fff;
		}
		.has-error .ant-form-explain, .has-error .ant-form-split{
			display: none;
		}
		.ant-form-inline .ant-form-item-with-help {
		    margin-bottom: 0;
		}
		.ant-form label{
			font-size: .8rem;
		}
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		
		 .ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		
		.wland{
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
		}
		
		.gland{
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	
	#tubody-mainsk1>div{
		padding: 1px 0;
	}
	
	#tubody-mainsk1{
		background-color: #fff;
		.main-mybody{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			min-height: 12rem;
			max-height: 30rem;
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		
		.main-wid{
			width: 85%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
		}
		.btnx {
			background-color: #0c8b97;
		}
		
		.btn2 {
			background-color: #f48d28;
		}
		
		.warp_daochu{
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem ;
		
			div{
				font-size: .7rem;
			}
		}
	}
	#on-center {
		.ant-form-item-label {
			margin-top: 1.5rem;
		}
	}

	#handitemedit1 {

		.ant-row,
		.ant-calendar-picker {
			width: 100%;
		}

		.ant-form-item-label {
			width: 15% !important;
		}

		.ant-form-item-control-wrapper {
			width: 70% !important;

			.wart-t {
				width: 100%;
			}
		}

		.ant-calendar-picker-input {
			width: 100%;
		}

		.myright {
			.ant-form-item-label {
				width: 30% !important;
				padding-left: 3.5%;
			}
		}

		.warp_long {
			width: 50%;
			display: inline-block;

			.ant-form-item-label {
				width: 30% !important;
			}

			.ant-form-item-control-wrapper {
				width: 60% !important;

			}
		}

		.texright {
			text-align: right;
			// margin-left: 4%;
		}
	}
</style>
